import React, {useState} from 'react';
import {ALARM_CHIP_TEXT, hasExactNfcText} from '../../services/alarmCoupling';
import NfcCard from '../shared/nfc/NfcCard';
import {useNfcOperation} from '../shared/nfc/useNfcOperation';
import {getNfcUnavailableMessage, scanNfcTag, writeNfcTag} from '../shared/nfc/webNfc';
import './NfcChipEditor.css';

const NfcChipEditor: React.FC<{disabled?: boolean}> = ({disabled}) => {
    const [value, setValue] = useState(ALARM_CHIP_TEXT);
    const [mode, setMode] = useState<'write' | 'verify'>('write');
    const operation = useNfcOperation<'write' | 'verify'>({
        disabled,
        identity: value,
        onSuccess: () => undefined,
    });
    const waiting = operation.state.phase === 'waiting';
    const blocked = disabled || waiting || !value.length || Boolean(getNfcUnavailableMessage());

    const write = () => {
        if (blocked) return;
        setMode('write');
        operation.start(async (session) => {
            await writeNfcTag(session, {type: 'text', value});
            return 'write';
        });
    };

    const verify = () => {
        if (blocked) return;
        setMode('verify');
        operation.start(async (session) => {
            const result = await scanNfcTag(session, {allowEmptyRecords: true});
            if (!hasExactNfcText(result, value)) {
                throw new Error('De inhoud van de chip komt niet exact overeen met de invoer.');
            }
            return 'verify';
        });
    };

    return (
        <NfcCard
            title="NFC-chip schrijven"
            description="Schrijf statische tekst naar een chip of controleer de inhoud van een bestaande chip."
            state={operation.state}
            actionLabel="Schrijf naar NFC-chip"
            retryLabel="Schrijf naar NFC-chip"
            waitingMessage={mode === 'write'
                ? 'Houd een beschrijfbare chip bij je telefoon'
                : 'Houd de chip bij je telefoon om de inhoud te controleren'}
            successMessage={mode === 'write' ? 'NFC-chip geschreven' : 'Chip gecontroleerd: de inhoud komt exact overeen'}
            validationMessage={value.length ? undefined : 'Vul tekst in om naar de chip te schrijven.'}
            disabled={disabled}
            onStart={write}
            onCancel={operation.cancel}
        >
            <label className="nfc-editor__label">
                NFC-inhoud
                <textarea value={value} disabled={disabled} onChange={(event) => setValue(event.target.value)}/>
            </label>
            <div className="nfc-card__actions nfc-editor__tools">
                <button type="button" className="nfc-card__cancel" disabled={disabled}
                        onClick={() => { operation.cancel(); setValue(ALARM_CHIP_TEXT); }}>
                    Alarmchip instellen
                </button>
                <button type="button" className="nfc-card__cancel" disabled={blocked} onClick={verify}>
                    Controleer chip
                </button>
            </div>
            <p className="nfc-card__write-note">De bestaande inhoud van de chip wordt overschreven.</p>
        </NfcCard>
    );
};

export default NfcChipEditor;
